import { ref } from "vue";
import { useSystemSettingsStore } from "@/stores/systemSettings";
import { usePos } from "@/composables/usePos";

export function useCds() {
  const { fetchPosById, getPosByXClientId } = usePos();
  const { getCdsClientId, setCdsClientId } = useSystemSettingsStore();

  const error = ref(null);

  const fetchCdsClientId = async () => {
    try {
      
      let clientId = getCdsClientId();
      if (!clientId) {
        const pos = await getPosByXClientId();
        if (pos && pos.type === "POS" && pos.status && pos.uuid) {
          /* Save CDS client id for websocket */
          await saveCdsClientId(pos);
        }
      }
      return clientId;
    } catch (err) {
      error.value =
        err?.message || `Error performing fetch operation`;
      throw err;
    }
  }

  let fetchPosAgain = true;
  const saveCdsClientId = async (pos) => {
    try {
      if (pos) {
        if (
          typeof pos.cds_entry === 'object' &&
          pos.cds_entry !== null &&
          !Array.isArray(pos.cds_entry) &&
          typeof pos.cds_entry.cds_uuid === 'string'
        ) {
          setCdsClientId(pos.cds_entry.cds_uuid);
        } else if (pos.id && fetchPosAgain) {
          const posObj = await fetchPosById(pos.id);
          if (posObj) {
            await saveCdsClientId(posObj);
          }
          fetchPosAgain = false;
        } else {
          console.warn("Invalid pos structure or missing cds_uuid:", pos);
        }
      }
    } catch (error) {
      console.error("Failed to save CDS client ID:", error);
    } finally {
      fetchPosAgain = true;
    }
  };
  
  return {
    fetchCdsClientId,
    saveCdsClientId
  }
}